import { render, staticRenderFns } from "./CostBearerEducationNotesPreview.vue?vue&type=template&id=035947fe&scoped=true&"
import script from "./CostBearerEducationNotesPreview.vue?vue&type=script&lang=ts&"
export * from "./CostBearerEducationNotesPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035947fe",
  null
  
)

export default component.exports